import { jsx } from "react/jsx-runtime";
import { EASINGS, getStroke } from "@tldraw/primitives";
import classNames from "classnames";
import { getSvgPathFromStroke } from "../utils/svg.mjs";
const DefaultScribble = ({
  scribble,
  zoom,
  color,
  opacity,
  className
}) => {
  if (!scribble.points.length)
    return;
  const d = getSvgPathFromStroke(
    getStroke(scribble.points, {
      size: scribble.size / zoom,
      start: { taper: true, easing: EASINGS.linear },
      last: scribble.state === "stopping",
      simulatePressure: false,
      streamline: 0.32
    })
  );
  return /* @__PURE__ */ jsx("svg", { className: className ? classNames("tl-overlays__item", className) : className, children: /* @__PURE__ */ jsx(
    "path",
    {
      className: "tl-scribble",
      d,
      fill: color ?? `var(--color-${scribble.color})`,
      opacity: opacity ?? scribble.opacity
    }
  ) });
};
export {
  DefaultScribble
};
//# sourceMappingURL=DefaultScribble.mjs.map
